import { ThemeProvider, createTheme } from '@mui/material/styles';
import { useMenuContext } from '../context';

type Props = {
  children: React.ReactNode;
};

export const MenuThemeProvider = ({ children }: Props) => {
  const { rtl, colors } = useMenuContext();

  const theme = createTheme({
    typography: {
      fontFamily: `var(--custom-font-family)`,
    },
    components: {
      MuiIconButton: {
        styleOverrides: {
          root: {
            borderRadius: '10px',
            '&:hover': {
              background: 'rgba(255, 255, 255, 0.2)',
            },
            '& .MuiTouchRipple-root .MuiTouchRipple-child': {
              borderRadius: '10px',
            },
          },
          sizeMedium: {
            width: 40,
            height: 40,
          },
          sizeSmall: {
            width: 25,
            height: 25,
          },
        },
      },
      MuiListItemButton: {
        styleOverrides: {
          root: {
            textAlign: rtl ? 'right' : 'left',
            borderRadius: '10px',
            margin: '3px 10px',
            paddingLeft: '15px',
            paddingRight: '15px',
            paddingTop: '5px',
            paddingBottom: '5px',

            '&:hover': {
              background: colors.hover,
              color: colors.text,
            },
          },
        },
      },
      MuiInputBase: {
        styleOverrides: {
          root: {
            input: {
              fontFamily: 'inherit',
            },
          },
        },
      },
    },
  });

  return <ThemeProvider theme={theme}>{children}</ThemeProvider>;
};
